module.exports = __webpack_public_path__ + "img/bb_img3.58fba092.png";